import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    modelValue: _ctx.alertVisible,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alertVisible) = $event)),
      _ctx.setVisible
    ],
    text: _ctx.alertText,
    type: _ctx.alertType,
    closable: _ctx.isDismissible,
    class: "headerNotification"
  }, null, 8, ["modelValue", "text", "type", "closable", "onUpdate:modelValue"]))
}